import { Injectable } from '@angular/core';
import { Errors, ErrorType } from 'src/app/shared/enums/error';
import { QuestionariType } from '../model/questionnaire-response';
import { IUser } from 'src/app/core/models/user.model';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { QuestionnairesService } from './questionnaires.service';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';

@Injectable({
  providedIn: 'root'
})
export class AnamnesisService {
  private patientSelectedId: string | null = null;
  private anamnesisSubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService,
  ) {
    this.anamnesisSubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getAnamnesis() {
    return this.anamnesisSubject.asObservable();
  }

  async loadAnamnesis(patientId: string, user: IUser): Promise<void> {

    this.anamnesisSubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'anamnesis', patientId, user.practitionerId)
      .then(result => {
        if (result) {
          this.anamnesisSubject.next({
            ...result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            today: { ...result?.today }
          });
        }
      });
  }

  async saveAnamnesis({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadAnamnesis(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de evolução.',
        error
      );
    }
  }

  async updateAnamnesis({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadAnamnesis(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de evolução.',
        error
      );
    }
  }
}
